import { ONBOARDING_PATHS } from "@jurni/schemas";
import { SLACK_PATHS } from "@/constants/slack";

const PUBLIC_ROUTES = [
  "/login",
  "/login/verify-email",
  "/login/reset-password",
  "/login/forgot-password",
];

export const isReviewRoute = (pathname: string) =>
  pathname.startsWith("/review/");

export const isPublicRoute = (pathname: string) =>
  PUBLIC_ROUTES.includes(pathname) || isReviewRoute(pathname);

export const ONBOARDING_ROUTES = [
  "/onboarding",
  ...Object.values(ONBOARDING_PATHS).map((p) => p.path),
];

export const NON_SHOP_ROUTES = [
  ...ONBOARDING_ROUTES,
  "/shop-not-connected",
  "/admin",
  "/invitation-failure",
  "/invitation-email-mismatch",
  ...Object.values(SLACK_PATHS),
];
